import { z } from "zod";

export const getProjectSchema = z.object({
	projectId: z.string().min(1),
});

export type GetProjectSchema = z.infer<typeof getProjectSchema>;
